import React, { useState } from "react";
import InputSelect from "../../../../../shared/components/inputs/InputSelect/InputSelect";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useLoading } from "../../../../../shared/context/LoadingContext";
import toast from "react-hot-toast";

function ModalConfiguracoesTipoAgendamento({
  openModal,
  handleModalClose,
  modalData,
  handleUpdate,
  clinicaId,
  sendRequest,
  auth,
}) {
  const [mensagemDeErro, setMensagemDeErro] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { startLoading, stopLoading } = useLoading();

  const [dados, setDados] = useState({
    tipo: modalData.tipo,
    atualizadoPor: modalData.atualizadoPor,
  });

  const submitHandler = async () => {
    try {
      setIsSubmitting(true);
      startLoading();

      const formData = new FormData();
      formData.append("nomeConfiguracao", "tipoAgendamento");
      formData.append("utilizador", auth.userId);
      formData.append("dadosAtualizacao", JSON.stringify(dados));

      const novaConfiguracao = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/configuracoes/${clinicaId}`,
        "PATCH",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        }
      );

      toast.success(
        "Configuração do tipo de agendamento atualizada com sucesso!"
      );
      handleUpdate(novaConfiguracao.configuracao);
    } catch (err) {
    } finally {
      stopLoading();
      setIsSubmitting(false);
      handleModalClose();
    }
  };

  const changeTipoAgendamento = (tipo) => {
    setDados((current) => ({ ...current, tipo: tipo }));
    setMensagemDeErro("");
  };

  return (
    <Modal
      open={openModal}
      onClose={handleModalClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        className="fluxo-atendimento__modal__box adicionar-categoria__modal"
        id="modal__adicionar-categoria"
      >
        <h1 className="fluxo-atendimento__modal__titulo">
          Configurações do tipo de agendamento
        </h1>
        <div
          className="adicionar-categoria__modal__container"
          style={{ marginTop: "25px" }}
        >
          <InputSelect
            className="adicionar-entrada__modal__container--span1"
            label="Tipo de Agendamento"
            initialValue={modalData.tipo || "Categoria de tratamento"}
            handleChange={changeTipoAgendamento}
            items={["Tratamento", "Categoria de tratamento"]}
          />
        </div>

        {mensagemDeErro && (
          <div className="erroContainer__categoria-caixa">{mensagemDeErro}</div>
        )}

        <div className="fluxo-atendimento__modal__bottom_btns">
          <span
            className="cancel-btn"
            onClick={handleModalClose}
            style={{ display: "block" }}
          >
            Fechar
          </span>

          <span
            disabled={isSubmitting}
            className="blue-button"
            onClick={submitHandler}
          >
            {isSubmitting ? "Guardando" : "Guardar"}
          </span>
        </div>
      </Box>
    </Modal>
  );
}

export default ModalConfiguracoesTipoAgendamento;
